<template>
  <div class="option-list" role="radiogroup" :aria-label="ariaLabel">
    <OptionCard
      v-for="option in options"
      :key="option.value"
      :label="option.label"
      :subtitle="option.subtitle"
      :selected="model === option.value"
      @click="handleSelect(option.value)"
    />
  </div>
</template>

<script setup lang="ts">
import OptionCard from './OptionCard.vue';

export interface OptionItem {
  value: string;
  label: string;
  subtitle?: string;
}

withDefaults(
  defineProps<{
    options: OptionItem[];
    ariaLabel?: string;
  }>(),
  {
    ariaLabel: '選択肢',
  },
);

const model = defineModel<string | null>({ default: null });

const emit = defineEmits<{
  select: [value: string];
}>();

const handleSelect = (value: string) => {
  model.value = value;
  emit('select', value);
};
</script>

<style lang="scss" scoped>
.option-list {
  display: flex;
  flex-direction: column;
}
</style>
